import { ModalName, ModalPropsType } from 'features/Modals';
import { modalStore } from 'state/store';

export const toggleModal = (modalName: ModalName, modalProps?: ModalPropsType) => {
    modalStore.toggleModal(modalName, modalProps);
};

export const openModal = (modalName: ModalName, modalProps?: ModalPropsType) => {
    modalStore.openModal(modalName, modalProps);
};
export const closeModal = () => {
    modalStore.closeModal();
};

export const useModal = () => {
    return {
        toggleModal,
        openModal,
        closeModal,
    };
};
